module.exports = __webpack_public_path__ + "674d6152d6a55412f6ca3e5ab4763520.png";